import React, { Component } from "react"
import { connect, getIn } from "formik"
import DatePicker from "../DatePicker"
import _ from "lodash"

class FormikDatePicker extends Component {
  props: {
    formik: any,
    name: string,
  }

  render () {
    const inputProps = _.omit( this.props, [ "formik" ] )

    const { name, formik } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    return (
      <DatePicker
        {...inputProps}
        value={value}
        error={touched && error ? error : undefined}
        onChange={date => formik.setFieldValue( name, date )}
        onBlur={formik.handleBlur( name )}
      />
    )
  }
}

export default connect( FormikDatePicker )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/DatePicker.jsx